export default __webpack_public_path__ + "static/media/utilResource.8256dfd4.svg";